import { Para } from 'ui-components';

type Props = {
  couponExpiration: string;
};

export default function ExpirationDate({ couponExpiration, ...props }: Props): React.ReactElement {
  return (
    <Para size="sm" align="center" {...props} className="text-zinc-400">
      Die Aktion ist gültig bis: {new Date(couponExpiration).toLocaleDateString()}
    </Para>
  );
}
